<div *ngIf="loading" class="qvs-validate-payment-order-request">
  <qvs-spinner-centered class="no-router-animation"></qvs-spinner-centered>
</div>
<div *ngIf="!loading" class="qvs-validate-payment-order-request">
  <qvs-validate-payment-order-request-proceed
    *ngIf="readyToSubmit"
    class="no-router-animation"
    [ordersPaymentRequest]="currentPaymentRequest"
    (closed)="close()"
  >
  </qvs-validate-payment-order-request-proceed>
  <qvs-validate-payment-order-request-uploading
    *ngIf="running"
    class="no-router-animation"
    [ordersPaymentRequest]="currentPaymentRequest"
    (closed)="close()"
  >
  </qvs-validate-payment-order-request-uploading>
  <qvs-validate-payment-order-request-failed
    *ngIf="failed"
    class="no-router-animation"
    [ordersPaymentRequest]="currentPaymentRequest"
    (closed)="close()"
  >
  </qvs-validate-payment-order-request-failed>
  <qvs-validate-payment-order-request-success
    *ngIf="success"
    class="fade-router-animation"
    [ordersPaymentRequest]="currentPaymentRequest"
    (closed)="close()"
  >
  </qvs-validate-payment-order-request-success>
</div>
